import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import APropos from "../pages/a-propos/page";
import Solutions from "../pages/solutions/page";
import AutresServices from "../pages/autres-services/page";
import Produits from "../pages/produits/page";
import Projets from "../pages/projets/page";
import Contact from "../pages/contact/page";
import Devis from "../pages/devis/page";
import ConditionsGenerales from "../pages/conditions-generales/page";
import PolitiqueConfidentialite from "../pages/politique-confidentialite/page";
import TelecomInfrastructures from "../pages/telecom-infrastructures/page";
import TelecomFibre from "../pages/telecom-fibre/page";
import TelecomMaintenance from "../pages/telecom-maintenance/page";
import GenieCivilBTP from "../pages/genie-civil-btp/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/a-propos",
    element: <APropos />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/autres-services",
    element: <AutresServices />,
  },
  {
    path: "/produits",
    element: <Produits />,
  },
  {
    path: "/projets",
    element: <Projets />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/devis",
    element: <Devis />,
  },
  {
    path: "/conditions-generales",
    element: <ConditionsGenerales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/telecom-infrastructures",
    element: <TelecomInfrastructures />,
  },
  {
    path: "/telecom-fibre",
    element: <TelecomFibre />,
  },
  {
    path: "/telecom-maintenance",
    element: <TelecomMaintenance />,
  },
  {
    path: "/genie-civil-btp",
    element: <GenieCivilBTP />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;